import { Component, OnInit, OnDestroy } from '@angular/core';
import { FacultyService } from '../../services/faculty.service';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { StatusService } from '../../services/status.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PushEventModalComponent } from '../push-event-modal/push-event-modal.component';
import { LoaderService } from '../../services/loader.service';
import { EventHandlers, WebsocketService } from '../../services/websocket.service';

@Component({
  selector: 'app-faculty-dashboard',
  templateUrl: './faculty-dashboard.component.html',
  styleUrls: ['./faculty-dashboard.component.css']
})
export class FacultyDashboardComponent implements OnInit, OnDestroy {
  batches: any[] = [];
  progressMessage: string = '';
  facultyId: number = 0;
  sseSub?: Subscription;
  status = '';
  ProcessId: any = '';

  constructor(private facultyService: FacultyService, private modalService: NgbModal, private authService: AuthService, private service: StatusService, private toaster: ToastrService, private loader: LoaderService, private socket: WebsocketService,) { }

  ngOnInit(): void {

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.facultyId = user.userId;
    console.log("faculty id is " + this.facultyId);
    console.log(user);
    this.loadBatches();

    this.socketEventHandlers;
    this.socket.socketEventHandlers;
    this.socket.setEventHandlers(this.socketEventHandlers);
    this.socket.createWebSocketConnection();
  }

  socketEventHandlers: EventHandlers = {
    "ProcessStatus": (data: any) => this.handleSocketMessage(data)
  };

  handleSocketMessage(data: any) {
    console.log(data);

  }

  ngOnDestroy(): void {
    this.sseSub?.unsubscribe();
  }

  onLogout() {
    this.authService.logout();
  }


  loadBatches(): void {
    this.facultyService.getBatches(this.facultyId).subscribe({
      next: (batchdata) => (this.batches = batchdata.Data),
      error: (err) => console.error('Error loading batches:', err)
    });
  }

  refresh(): void {
    this.loadBatches();
  }

  pushEvents(batch: any): void {
    const modalRef = this.modalService.open(PushEventModalComponent, {
      windowClass: 'push-event-modal',
      backdrop: 'static',
      backdropClass: 'push-event-backdrop',
    });
    modalRef.componentInstance.batch = batch;
    modalRef.result.then(
      (result) => {
        console.log('Final Submitted Events:', result);
      },
      () => { }
    );
  }

  pushAutoVals(batch: any): void {
    this.progressMessage = `Starting autovals for batch ${batch.BatchName}...`;
    this.sseSub = this.facultyService.pushAutoVals(batch).subscribe({
      next: (msg) => (this.progressMessage = msg),
      error: (err) => (this.progressMessage = 'Error: ' + err.message),
      complete: () => (this.progressMessage = 'Autovals completed successfully!')
    });
  }

  // processRound(batch: any): void {
  //   this.status = 'Starting...';
  //   const batchId = batch.SDBatchId;


  //   this.facultyService.processRound(batchId).subscribe((resp) => this.ProcessId = resp.Data.processId);
  //   this.facultyService.pollStatus(this.ProcessId).subscribe((sresp) => this.status = sresp.Data.status);
  // }

  processRound(batch: any): void {
  this.status = 'Starting...';
  const batchId = batch.SDBatchId;

  this.facultyService.processRound(batchId).subscribe(resp => {
    this.ProcessId = resp.Data.processId;

    // ✅ call after processRound
    this.loadBatches();

    // ✅ start polling only after ProcessId is set
    this.facultyService.pollStatus(this.ProcessId).subscribe(sresp => {
      this.status = sresp.Data.status;
    });
  });
}


  getReports(batch: any): void {
    this.facultyService.getReports(batch).subscribe({
      next: (res) => {
        alert(res.message);
        window.open(res.downloadUrl, '_blank');
      },
      error: (err) => this.toaster.error('Error generating reports', 'Error')
    });
  }


  restorePreviousRound(b: any) {
    this.loader.showLoader();
    this.facultyService.restorePreviousRound(b.SDBatchId, b.RoundsPlayed).subscribe((resp) => {
      if (resp.errorCode === '000000') {
        this.toaster.success(resp.errorDescription, 'Success');
        this.loader.hideLoader();
        this.loadBatches();
      } else {
        this.toaster.error(resp.errorDescription, 'Error');
        this.loader.hideLoader();

      }
    });
  }

}
